import $ from "jquery"

# ==================================================
# > CLASSES
# ==================================================
class Year
    constructor: (@$year, @$content) ->

    activate: ->
        @$year.addClass "current"
        @$content.slideDown()

    desactivate: ->
        @$year.removeClass "current"
        @$content.slideUp()


class Timeline
    constructor: (@$wrapper) ->

        @$years    = @$wrapper.find(".timeline li")
        @$contents = @$wrapper.find(".content")

        @years   = @getYears()
        @current = 0


    getYears: ->
        years = []

        @$years.each (i, el) =>
            $(el).click => @setYear i
            years.push new Year $(el), @$contents.filter("[data-year=" + $(el).data("year") + "]")

        return years

    setYear: (index) ->
        @years[@current].desactivate()
        @current = index
        @years[@current].activate()

    nextYear: ->
        toGo = if @current + 1 > @years.length - 1 then 0 else @current + 1
        @setYear toGo

    prevYear: ->
        toGo = if @current - 1 < 0 then @years.length - 1 else @current - 1
        @setYear toGo

# ==================================================
# > INIT
# ==================================================
$ ->
    $(".timeline-wrapper").each ->
        timeline = new Timeline $(@)

        $(@).find(".prev").click -> timeline.prevYear()
        $(@).find(".next").click -> timeline.nextYear()


// WEBPACK FOOTER //
// ./scripts/modules/timeline.coffee